(function ($, undefined) {
    var sm = window.sm = window.sm || {};

    if (typeof sm.portal === "undefined") {
        $.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        $.extend(sm.portal, { vm: {} });
    }

    // SUPPORTING MODEL
    // This is the model that tracks the Country-Template associations
    function AddressTemplateCountryViewModel(options) {
        var defaults = {
            ID: 0,
            GID: null,
            Name: '',
            Description: '',
            IsSystemCountry: false,
            IsCountryDefault: false,
            Templates: []
        };

        var settings = $.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        this.IsSystemCountry = ko.observable(settings.IsSystemCountry);
        this.IsCountryDefault = ko.observable(settings.IsCountryDefault);
        this.Name = ko.observable(settings.Name);
        this.Description = ko.observable(settings.Description);
        this.ID = ko.observable(settings.ID);
        this.GID = ko.observable(settings.GID);
        this.Templates = ko.observableArray(settings.Templates);

        return self;
    }

    $.extend(true, sm.portal.vm, {
        AddressTemplateCountryViewModel: AddressTemplateCountryViewModel
    });

})(jQuery);